import CalculateIcon from '@mui/icons-material/Calculate';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import MapIcon from '@mui/icons-material/Map';
import { Box, Card, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { BikeleasingBIcon } from 'probonio-shared-ui/component/icon';
import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BackIconButton } from '../../component/button/BackIconButton';
import { MobileLayout } from '../../component/layout';
import { AppToolbar } from '../../component/layout/AppToolbar';
import { BikeleasingContent, BikeleasingTabs } from '../../module/benefit/bikeleasing';
import { HighlightGuideButton } from '../../module/guiding';

export const BikeleasingPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation('benefitModule');
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tab =
    tabParam === BikeleasingTabs.overview || tabParam === BikeleasingTabs.calculator || tabParam === BikeleasingTabs.vendorMap
      ? tabParam
      : BikeleasingTabs.overview;

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: BikeleasingTabs) => {
      setSearchParams({ tab: newValue });
    },
    [setSearchParams],
  );

  const navigateInfo = useCallback(() => {
    navigate('info');
  }, [navigate]);

  return (
    <MobileLayout
      iosOverloadScrollBackground={theme.palette.background.paper}
      header={
        <Card sx={{ borderRadius: 0, boxShadow: 0 }}>
          <AppToolbar
            title={
              <Box display="flex" flexDirection="row" alignItems="center" gap={0.5}>
                <BikeleasingBIcon fontSize="extraLarge" />
                <Typography variant="extraBig">{t('benefit.BIKELEASING.name')}</Typography>
              </Box>
            }
            backButton={<BackIconButton to={'/home'} />}
            actionButton={
              <HighlightGuideButton
                name={t('benefit.BIKELEASING.name')}
                header={t('benefit.BIKELEASING.firstHelpGuide.header')}
                text={t('benefit.BIKELEASING.firstHelpGuide.text')}
                onClick={navigateInfo}
              />
            }
          />
          <Tabs value={tab} onChange={handleChange}>
            <Tab value={BikeleasingTabs.overview} icon={<LightbulbIcon />} sx={{ flex: 1 }} />
            <Tab value={BikeleasingTabs.calculator} icon={<CalculateIcon />} sx={{ flex: 1 }} />
            <Tab value={BikeleasingTabs.vendorMap} icon={<MapIcon />} sx={{ flex: 1 }} />
          </Tabs>
        </Card>
      }
    >
      <BikeleasingContent tab={tab} />
    </MobileLayout>
  );
};
